import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import ChangesIcon from '@atlaskit/icon/core/changes';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-all-fields-action-renderer.ui.action-card.priority-field.icon-label',
		defaultMessage: 'Priority field icon',
		description:
			'Accessible label for the icon representing the priority field in a Jira work item action card.',
	},
});

export function PriorityFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<ChangesIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
